import React from 'react'
import PropTypes from 'prop-types'
import { ExternalLink, InternalLink, Text } from './Breadcrumb.styles'

/**
 * The Breadcrumb's component.
 */
const Breadcrumb = props => {
  const { children, target, to, type, variant, ...restProps } = props

  if (variant === 'text') {
    return <Text {...restProps}>{children}</Text>
  }

  if (type === 'external' && variant === 'link') {
    return (
      <ExternalLink {...restProps} href={to} target={target}>
        {children}
      </ExternalLink>
    )
  }

  return (
    <InternalLink {...restProps} to={to}>
      {children}
    </InternalLink>
  )
}

Breadcrumb.defaultProps = {
  margin: 0,
  padding: 0,
  target: '_blank',
  to: '#',
  type: 'internal',
  variant: 'text'
}

Breadcrumb.propTypes = {
  /**
   * Children.
   */
  children: PropTypes.node.isRequired,
  /**
   * Margin.
   */
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Padding.
   */
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Target.
   */
  target: PropTypes.string,
  /**
   * To.
   */
  to: PropTypes.string,
  /**
   * Type.
   */
  type: PropTypes.oneOf(['external', 'internal']),
  /**
   * Variant.
   */
  variant: PropTypes.oneOf(['link', 'text'])
}

export default Breadcrumb
